package games.mythical.saga.watcher.sagawatcher.frontend.component

import csstype.Color
import csstype.None.none
import csstype.Position.Companion.absolute
import csstype.px
import emotion.react.css
import games.mythical.saga.watcher.sagawatcher.frontend.ApplicationProps
import games.mythical.saga.watcher.sagawatcher.frontend.layout.Sizes
import mui.material.*
import mui.material.DrawerAnchor.left
import mui.system.Box
import mui.system.sx
import react.*
import react.dom.html.ReactHTML.nav
import react.router.dom.NavLink
import react.router.useLocation
import mui.icons.material.Menu as MenuIcon

val Menu = FC<ApplicationProps> { props ->
    var isOpen by useState(false)

    val lastPathname = useLocation().pathname.substringAfterLast("/")

    Box {
        component = nav

        SwipeableDrawer {
            anchor = left
            open = isOpen
            onOpen = { isOpen = true }
            onClose = { isOpen = false }

            Box {
                Toolbar()

                List {
                    sx { width = Sizes.Sidebar.Width }

                    for ((key, app) in props.applications) {
                        NavLink {
                            to = key

                            css {
                                textDecoration = none
                                color = Color.currentcolor
                            }

                            ListItemButton {
                                selected = lastPathname == key

                                ListItemText {
                                    primary = ReactNode(app.name)
                                }
                            }
                        }
                    }
                }
            }
        }

        SpeedDial {
            sx {
                position = absolute
                bottom = 16.px
                left = 16.px
            }
            ariaLabel = "Menu"
            icon = MenuIcon.create()
            onClick = { isOpen = true }
        }
    }
}
